<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Accounts from './accounts';


export default {
  page: {
    title: "Smart Exchange",
    meta: [{ name: "description" }]
  },
  components: { Layout, PageHeader, Accounts },
  data() {
    return {
      title: "Smart Exchange",
      items: [
        "Account Balances"
      ]
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-lg-12 ">
            <Accounts/>
        </div>
    </div>
  </Layout>
</template>